import type { BlobItem as BlobItemType } from "@azure/storage-blob";
import { BlobInfo } from "./BlobInfo";
import { BlobActions } from "./BlobActions";

interface BlobItemProps {
  blob: BlobItemType;
  index: number;
  onView?: (blob: BlobItemType) => void;
}

export function BlobItem({
  blob,
  index,
  onView
}: BlobItemProps) {
  return (
    <li key={`${blob.name}-${index}`} className="px-4 py-2">
      <div className="flex items-center justify-between">
        <BlobInfo blob={blob} />
        <BlobActions blob={blob} onView={onView} />
      </div>
    </li>
  );
}